import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { VincleFontService } from '@app/core/services/icons/vincle-font.service';
import { InputSearchComponent } from '@components/form-controls/inputs/input-search/input-search.component';
import { DialogBaseComponent } from '@components/modals/dialog-base/dialog-base.component';
import { fromEvent, merge, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, tap } from 'rxjs/operators';
@Component({
  selector: 'vfs-icon-selection',
  templateUrl: './icon-selection.component.html',
  styleUrls: ['./icon-selection.component.scss']
})
export class IconSelectionComponent extends DialogBaseComponent implements AfterViewInit {
  font$: Observable<string[]>;
  changeEvent$: Observable<string[]>;
  keyupEvent$: Observable<string[]>;

  iconSelected: string;
  loading = true;
  totalIcons = 0;
  searchItem = '';
  searchChanged = false;
  pageSizeOptions: number[];
  pageSize: number;
  pageChanged: boolean;

  @ViewChild('inputSearch') inputSearch: InputSearchComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IconSelectionComponent>,
    private vincleFontService: VincleFontService
  ) {
    super(dialogRef);
    this.iconSelected = data.iconSelected;
    this.pageSizeOptions = [150, 300, 450];
    this.pageSize = 150;
  }

  ngAfterViewInit() {
    this.changeEvent$ = fromEvent(this.inputSearch.inputRef.nativeElement, 'change').pipe(
      debounceTime(250),
      distinctUntilChanged(),
      map(_ => this.inputSearch.inputRef.nativeElement.value),
      tap(result => {
        this.searchItem = result;
        this.searchChanged = true;
      })
    );

    this.keyupEvent$ = fromEvent(this.inputSearch.inputRef.nativeElement, 'keyup').pipe(
      debounceTime(250),
      distinctUntilChanged(),
      map(_ => this.inputSearch.inputRef.nativeElement.value),
      tap(result => {
        this.searchItem = result;
        this.searchChanged = true;
      })
    );

    // Fusion of two observables
    this.font$ = merge(
      this.changeEvent$,
      this.keyupEvent$,
      // Changes in pagination are observed
      this.paginator.page
    ).pipe(
      // Start with empty search
      startWith(''),
      switchMap(result => {
        // Subscription to the service call to get your result
        this.loading = true;
        // We pass the results to the service function
        return this.vincleFontService.loadIcons(
          this.searchItem,
          this.searchChanged ? 0 : this.paginator.pageIndex,
          this.paginator.pageSize,
          this.iconSelected,
          this.pageChanged
        );
      }),
      tap(result => {
        this.paginator.pageIndex = result.selectedPage;
      }),
      map(result => {
        this.searchChanged = false;
        this.loading = false;
        this.totalIcons = result.total;
        // We keep the list of icons
        return result.icons;
      })
    );
  }

  /**
   * Function to return the selected icon when accepting
   */
  acceptIconSelected() {
    this.dialogRef.close(this.iconSelected);
  }

  /** Function to return the default icon if it has been canceled */
  cancelIconSelected() {
    this.dialogRef.close(this.data.iconSelected);
  }

  /**
   * To determine if a page change event has been emitted
   */
  pageSelected() {
    this.pageChanged = true;
  }

  toggleIcon(icon: string) {
    this.iconSelected = this.iconSelected !== icon ? icon : '';
  }
}
